import axios from 'axios';
import { jwtTokenPromise } from 'nike-ui/src/common/axios/jwtTokenPromise';

if (!axios.__nike_setup) {
    throw Error('wrong axios create order');
}
const betslipClient = axios.create();

betslipClient.interceptors.response.use(response => response.data);
betslipClient.interceptors.request.use(config =>
    jwtTokenPromise().then(token => {
        config.headers['Authorization'] = `Bearer ${token}`;
        if (window.USER_DATA_SNAPSHOT.cisloZmluvy) {
            config.headers['Contract-Id'] = window.USER_DATA_SNAPSHOT.cisloZmluvy;
        }
        return config;
    })
);

export default betslipClient;
